import React from 'react';

import { usePathnameMethod } from '../utils/hook/usePathnameMethod';

import { CustomLink } from './CustomLink';

interface PCHeaderMenuButtonProps {
  onClick: () => void;
  pathName?: string;
  name: string | React.ReactNode;
  rightEl?: React.ReactNode;
}

function PCHeaderMenuButton({
  onClick,
  pathName,
  name,
  rightEl,
}: PCHeaderMenuButtonProps) {
  const { pathname } = usePathnameMethod();

  const commonProps = {
    onClick,
    className: `relative block px-22px text-sm flex items-center gap-4px ${
      pathname === pathName ? 'font-bold text-brand-1' : 'text-gray-500'
    }`,
  };

  return (
    <li>
      {pathName ? (
        <CustomLink href={pathName} {...commonProps}>
          <span className="whitespace-nowrap">{name}</span>
          <span>{rightEl}</span>
        </CustomLink>
      ) : (
        <button {...commonProps} type="button">
          <span>{name}</span>
          {rightEl}
        </button>
      )}
    </li>
  );
}

export default PCHeaderMenuButton;
